<template>
  <div class="play_userPop">
    <div class="olay_pop">
      <div class="play_pop_left">
        <div class="left_contenBox olap_pop_gundong">
          <div class="left_top">
            <div class="avatar_holder">XX</div>
            <div class="identifiers">
              <p>{{ userInfo.name }}</p>
            </div>
          </div>
          <div class="left_content_bc">
            <div class="user_balance">
              <p class="u-title-bc">{{ $t("主要余额") }}</p>
              <p class="u-money-bc">R& {{ userInfo.ml_money }}</p>
              <div class="buttin-bc">
                <div @click="selectTile = $t('存款')" class="deposit-bc">
                  {{ $t("存款") }}
                </div>
                <div @click="selectTile = $t('取款')" class="deposit-bc">
                  {{ $t("取款") }}
                </div>
              </div>
            </div>
          </div>
          <div class="collapseMy">
            <el-collapse v-model="activeNames">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="coll_newTitle">
                    <span class="iconfont icon-7tiantuihuo"></span>
                    <span>{{ $t("历史记录") }}</span>
                  </div>
                </template>
                <div class="coll_allSon">
                  <div class="coll_son" @click="selectTile = $t('游戏记录')">
                    {{ $t("游戏记录") }}
                  </div>
                  <div class="coll_son" @click="selectTile = $t('交易记录')">
                    {{ $t("交易记录") }}
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="play_pop_right olap_pop_gundong">
        <div class="right_top">
          <div>{{ selectTile }}</div>
          <div @click="close">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div v-if="selectTile == $t('存款')" class="recharge">
          <div class="pay">
            <div class="pay_type" @click="selectPay = item" :class="selectPay == item ? 'select' : ''"
              v-for="(item, index) in pay" :key="index">
              <img :src="item.currencyIcon" alt="" srcset="" />
            </div>
          </div>
          <div class="pay_specific">
            <div class="showData">
              <table>
                <tr>
                  <th>{{ $t("付款名称") }}</th>
                  <th>{{ $t("费用") }}</th>
                  <th>{{ $t("时间") }}</th>
                  <th>{{ $t("最小") }}</th>
                  <th>{{ $t("最大") }}</th>
                </tr>
                <tr>
                  <td>{{ selectPay2.type_text }}</td>
                  <td>{{ $t("免费") }}</td>
                  <td>{{ $t("立即生效") }}</td>
                  <td>{{ selectPay2.min }}</td>
                  <td>{{ selectPay2.max }}</td>
                </tr>
              </table>
            </div>
            <!-- 银行参数 -->
            <div class="bank" v-if="selectPay2.country != 'India'">
              <div class="bank_select">
                <div>{{ $t("银行选择") }}：</div>
                <div class="bank_type">
                  <div class="one" @click="post_data.bank_code = 'PIX'"
                    :class="post_data.bank_code == 'PIX' ? 'select' : ''">
                    CPF
                  </div>
                  <div class="two" @click="post_data.bank_code = 'PIXN'"
                    :class="post_data.bank_code == 'PIXN' ? 'select' : ''">
                    CNPJ
                  </div>
                </div>
              </div>
              <div class="bank_input">
                <div>{{ $t("银行账户") }}：</div>
                <input v-model="post_data.attach" type="text" />
              </div>
            </div>
            <div class="money_number">
              <div class="number_input">
                <div>{{ $t("充值金额") }}：</div>
                <div>
                  <input :placeholder="$t('请输入金额')" v-model="post_data.money" type="text" />
                </div>
              </div>
              <div @click="submitPay" class="money_submit">
                {{ $t("充值") }}
              </div>
            </div>
          </div>
        </div>
        <div class="game_record" v-if="selectTile == $t('游戏记录')">
          <div class="gameTitle">
            <table border="0" cellspacing="0">
              <tr class="table-title">
                <td>{{ $t("游戏品牌") }}</td>
                <td>{{ $t("游戏名称") }}</td>
                <td>{{ $t("下注时间") }}</td>
                <td>{{ $t("下注金额") }}</td>
                <td>{{ $t("输赢金额") }}</td>
              </tr>
            </table>
          </div>
          <div v-if="tableDataGame.length != 0" class="have_data">
            <table border="0" cellspacing="0">
              <tr class="table-title" v-for="(item, index) in tableDataGame" :key="index">
                <td>{{ item.api_name }}</td>
                <td>{{ $t(`${item.gameName}`) }}</td>
                <td>{{ item.betTime }}</td>
                <td>{{ $t(`${item.betAmount}`) }}</td>
                <td>{{ $t(`${item.netAmount}`) }}</td>
              </tr>
            </table>
          </div>
          <div v-else>{{ $t("暂无数据") }}</div>
        </div>
        <div class="transaction" v-if="selectTile == $t('交易记录')">
          <div class="transactionTitle">
            <table border="0" cellspacing="0">
              <tr class="table-title">
                <td>{{ $t("申请时间") }}</td>
                <td>{{ $t("存款金额") }}</td>
                <td>{{ $t("状态") }}</td>
              </tr>
            </table>
          </div>
          <div>
            <div class="have_data" v-if="tableData.length != 0">
              <table border="0" cellspacing="0">
                <tr class="table-title" v-for="(item, index) in tableData" :key="index">
                  <td>{{ item.updated_at }}</td>
                  <td>{{ item.money_after }}</td>
                  <td>{{ $t(`${item.operate_type_text}`) }}</td>
                </tr>
              </table>
            </div>
            <div v-else>{{ $t("暂无数据") }}</div>
          </div>
        </div>
        <div v-if="selectTile == $t('取款')">
          <div class="form ababab">
            <div class="pay">
              <div class="pay_type" @click="selectPay = item" :class="selectPay == item ? 'select' : ''"
                v-for="(item, index) in txPay" :key="index">
                <img :src="item.currencyIcon" alt="" srcset="" />
              </div>
            </div>
            <div class="pay_specific">
              <div class="showData">
                <table>
                  <tr>
                    <th>{{ $t("付款名称") }}</th>
                    <th>{{ $t("费用") }}</th>
                    <th>{{ $t("时间") }}</th>
                    <th>{{ $t("最小") }}</th>
                    <th>{{ $t("最大") }}</th>
                  </tr>
                  <tr>
                    <td>{{ selectPay2.type_text }}</td>
                    <td>{{ $t("免费") }}</td>
                    <td>{{ $t("立即生效") }}</td>
                    <td>{{ selectPay2.min }}</td>
                    <td>{{ selectPay2.max }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <el-form ref="formt" :model="formData" :rules="rules">
              <el-form-item :label="$t('收款名称')" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('账号类型')" prop="payment_type">
                <el-select v-model="formData.payment_type" :placeholder="$t('请选择')">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('收账账号')" prop="account">
                <el-input v-model="formData.account"></el-input>
              </el-form-item>
              <!-- <el-form-item :label="$t('CPF号码')" prop="member_bank_id">
                <el-input v-model="formData.member_bank_id"></el-input>
              </el-form-item> -->
              <el-form-item :label="$t('金额')" prop="money">
                <el-input v-model="formData.money"></el-input>
              </el-form-item>
              <el-form-item :label="$t('提现密码')" prop="qk_pwd">
                <el-input v-model="formData.qk_pwd"></el-input>
              </el-form-item>
              <el-form-item style="display: flex;align-items: center;justify-content: center;">
                <el-button type="primary" @click="submitMoney('formt')"
                  style="background: linear-gradient(1deg, #d2b985 0%, #d1b983 26%, #f0d48d 44%, #c6ac60 64%, #c7ad61 100%);width: 250px;border: none;">
                  {{
                $t("提现")
              }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  payments,
  axiosOnline,
  recharge,
  gamerecord,
  transactionRecord,
  Withdraw
} from "@/api/apiIndex.js";
export default {
  name: "Gamenew2UserPop",
  props: {
    userPopShow: {
      type: Boolean,
      default: false
    },
    righttop: {
      type: String,
      default: "Deposit"
    }
  },
  watch: {
    userPopShow() {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    },
    selectPay: function (newVal, oldVal) {
      if (newVal) {
        for (let index = 0; index < this.xxData.length; index++) {
          if (this.xxData[index].type == newVal.type) {
            this.selectPay2 = this.xxData[index];
          }
        }
      }
    }
  },
  data() {
    return {
      options: [],
      formData: {
        name: '',//名称
        money: '',//钱
        account: '',//账号
        qk_pwd: '',//密码
        payment_type: '',//类型
        // member_bank_id:''//CPF
      },
      rules: {
        name: [{ required: true, message: this.$t('请输入名称'), trigger: 'blur' }],
        money: [{ required: true, message: this.$t('请输入提现金额'), trigger: 'blur' }],
        account: [{ required: true, message: this.$t('请输入账号'), trigger: 'blur' }],
        qk_pwd: [{ required: true, message: this.$t('请输入密码'), trigger: 'blur' }],
        payment_type: [{ required: true, message: this.$t('请选择类型'), trigger: 'blur' }],
        // member_bank_id:[{ required: true, message: this.$t('请输入CPF'), trigger: 'blur' }]
      },
      activeNames: [],
      userInfo: {},
      selectTile: "Deposit",
      pay: null,
      txPay: null,
      selectPay: null,
      selectPay2: null,
      xxData: [],
      // 提交充值的数据
      post_data: {
        money: null,
        payment_desc: "",
        payment_id: "",
        payment_type: "",
        bank_code: "PIX",
        attach: ""
      },
      // 游戏记录
      pageGame: "1",
      last_pageGame: "1",
      tableDataGame: "",
      // 交易记录
      page: "1",
      last_page: "1",
      tableData: []
    };
  },
  async created() {
    this.selectTile = this.righttop;
    await this.getPay();
    await this.getPay2();
    this.ShowAxiosGame();
    this.ShowAxios();
  },
  methods: {
    // 提款提交
    submitMoney(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = { ...this.formData }
          obj.payment_type = this.selectPay.type + '-' + this.formData.payment_type
          Withdraw(obj).then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t("提现成功"));
            } else {
              this.$message.error(res.msg);
            }

          })
        } else {
          this.$message.error(this.$t("请输入正确的参数"));
          return false;
        }
      });
    },
    // 交易记录
    ShowAxios() {
      let time = new Date();
      let threeMonthsAgo = new Date(time.setMonth(time.getMonth() - 3));
      time = new Date();
      let obj = {
        created_at: [
          threeMonthsAgo.toLocaleDateString().replaceAll("/", "-") +
          " 00:00:00",
          time.toLocaleString().replaceAll("/", "-")
        ],
        money_type: "",
        operate_type: "",
        page: 1
      };
      transactionRecord(obj)
        .then(res => {
          this.page = res.data.current_page;
          this.last_page = res.data.last_page;
          this.tableData = res.data.data;
        })
        .catch(err => {
          // 
        });
    },
    // 游戏记录
    ShowAxiosGame() {
      let time = new Date();
      let obj = {
        betTime: [
          time.toLocaleDateString().replaceAll("/", "-") + " 00:00:00",
          time.toLocaleString().replaceAll("/", "-")
        ],
        limit: 30,
        page: 1
      };
      gamerecord(obj)
        .then(res => {
          this.pageGame = res.data.current_page;
          this.last_pageGame = res.data.last_page;
          this.tableDataGame = res.data.data;
        })
        .catch(err => {
          // 
        });
    },
    // 支付方式
    getPay() {
      this.options = [];
      return new Promise((resolve, reject) => {
        payments({
          lang: JSON.parse(localStorage.getItem("language")).value,
          domain: location.hostname =='localhost'? '63s.online' : location.hostname
        })
          .then(res => {
            if (res.code == 200) {
              // 充值用
              this.pay = res.data.payment_type.filter(v => {
                return v.type_text.indexOf('-') == -1
              });
              // 提现用
              this.txPay = res.data.payment_type.filter(v => {
                return v.type_text.indexOf('-') != -1
              });
              this.txPay.forEach(v => {
                v.type = v.type.slice(0, v.type.indexOf('-'))
              })
              this.txPay = this.arrQuchong(this.txPay, 'type')
              let arr = res.data.payment_type.filter(v => {
                return v.type_text.indexOf('-') != -1
              })
              arr.forEach(v => {
                let type = v.type_text.slice(v.type_text.indexOf('-') + 1);
                this.options.push({ label: type, value: type })
              })
              // 被选择项
              if (this.selectTile == this.$t('取款')) {
                this.selectPay = this.txPay[0];
              } else {
                this.selectPay = this.pay[0];
              }
              resolve();
            } else {
              this.$message.error(res.message);
              reject();
            }
          })
          .catch(err => {
            // 返回code为401 token过期 公共js
            if (this.comJs.tokenIsExpire(err.response.data.code)) {
              return;
            }
            reject();
          });
      });
    },
    // 去重
    arrQuchong(array, key) {
      const _set = [...new Set(array.map(e => e[key]))];
      let deArray = [];
      _set.map(item => {
        deArray.push(array[array.findIndex(val => val[key] === item)])
      })
      return deArray
    },
    // 具体支付限制
    getPay2() {
      return new Promise((resolve, reject) => {
        let axOnline = {
          lang: JSON.parse(localStorage.getItem("language")).value,
          domain: location.hostname =='localhost'? '63s.online' : location.hostname
        };
        axiosOnline(axOnline)
          .then(res => {
            if (res.code == 200) {
              this.xxData = res.data;
              for (let index = 0; index < this.xxData.length; index++) {
                if (this.selectPay.type == this.xxData[index].type) {
                  this.selectPay2 = this.xxData[index];
                }
              }
              resolve();
            } else {
              this.$message.error(res.message);
              reject();
            }
          })
          .catch(err => {
            // 返回code为401 token过期 公共js
            if (this.comJs.tokenIsExpire(err.response.data.code)) {
              return;
            }
            reject();
          });
      });
    },
    // 提交支付
    submitPay() {
      if (this.isSub) return;
      if (this.money == "") {
        this.$message.error(this.$t("请输入金额"));
        return;
      }
      if (this.money < this.selectPay2.min) {
        this.$message.error(
          `${this.$t("金额不得小于")} ${this.selectPay2.min}`
        );
        return;
      }
      if (this.money > this.selectPay2.max) {
        this.$message.error(
          `${this.$t("金额不得大于")} ${this.selectPay2.max}`
        );
        return;
      }
      this.post_data.payment_desc = this.selectPay2.desc;
      this.post_data.payment_type = this.selectPay2.type;
      if (this.post_data.attach == "") {
        this.post_data.attach = "12345678910";
      }
      recharge(this.post_data)
        .then(res => {
          this.isSub = false;
          if (res.code == 200) {
            if ("pay_url" in res) {
              window.location.href = res.pay_url;
            }
          } else {
            this.post_data.attach = "";
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.isSub = false;
          if (this.comJs.tokenIsExpire(err.response.data.code)) {
            return;
          }
          this.post_data.attach = "";

          this.$message.error(err.response.data.message);
        });
    },
    close() {
      this.$emit("changeShowLogin", false);
    }
  }
};
</script>


<style lang="less" scoped>
.play_userPop {
  width: 100%;
  min-width: 1024px;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;

  .olay_pop {
    width: 90%;
    height: 80vh;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #01311c5c !important;
    z-index: 1001;
    display: flex;
    box-shadow: 0 0 5px 0 rgba(11, 11, 11, 0.1);
    border-radius: 10px;
    backdrop-filter: blur(14px);

    .play_pop_left {
      width: 320px;
      height: 100%;
      padding: 12px 7px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.1);

      .left_contenBox {
        height: 100%;

        .left_top {
          font-size: 12px;
          height: 36px;
          margin-bottom: 10px;
          padding: 0 10px;
          color: rgba(255, 255, 255, 0.9);
          display: flex;

          .avatar_holder {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            border-radius: 50%;
            height: 100%;
            width: 36px;
            color: white;
            background: rgba(255, 255, 255, 0.4);
          }

          .identifiers {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            p:nth-child(2) {
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }

        .left_content_bc {
          padding: 10px 15px;
          margin-bottom: 14px;
          min-height: 100px;
          border-radius: 6px;
          position: relative;

          .user_balance {
            position: relative;
            z-index: 1;
            color: white;

            .u-title-bc {
              font-size: 14px;
            }

            .u-money-bc {
              font-size: 20px;
              font-weight: 700;
              margin: 0 0 12px 0;
            }

            .buttin-bc {
              height: 35px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .deposit-bc {
                cursor: pointer;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                width: 48%;
                border-radius: 6px;
                background: hsla(0, 0%, 100%, 0.25);
              }
            }

            .bonus-info-section {
              font-size: 12px;
              padding-top: 10px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-top: 1px solid hsla(0, 0%, 100%, 0.2);
            }
          }

          &:nth-child(2) {
            background: #109121;
          }

          &:nth-child(3) {
            background: #aa7f00;
            margin-bottom: 40px;
          }

          &::after {
            position: absolute;
            left: 0;
            top: 0;
            content: "";
            width: 100%;
            height: 100%;
            opacity: 0.9;
            background: radial-gradient(circle at -14% 113%,
                hsla(0, 0%, 100%, 0.3),
                hsla(0, 0%, 100%, 0) 135%);
          }
        }

        /deep/.collapseMy {
          .el-collapse {
            border: 0px !important;
          }

          .el-collapse-item__header {
            color: rgba(255, 255, 255, 0.8);
            background: rgba(255, 255, 255, 0.05);
            border: 0px !important;
          }

          .el-collapse-item__wrap {
            background: rgba(255, 255, 255, 0.1);
            border: 0;
          }

          .el-collapse-item__content {
            color: rgba(255, 255, 255, 0.6);
            padding: 0;
            padding: 10px 0 10px 15px;
          }

          .coll_newTitle {
            padding-left: 15px;
            font-size: 14px;
            display: flex;
            align-items: center;

            .iconfont {
              font-size: 20px;
              margin-right: 8px;
            }
          }

          .coll_allSon {
            border-left: 1px solid rgba(255, 255, 255, 0.1);
            padding-left: 12px;

            .coll_son {
              height: 30px;
              cursor: pointer;
            }
          }
        }
      }
    }

    .play_pop_right {
      flex: 1;
      height: 100%;
    }
  }
}

.olap_pop_gundong {
  overflow-y: auto;
}

/* 滚动条宽 */
.olap_pop_gundong::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* 滚动条 背景颜色 */
.olap_pop_gundong::-webkit-scrollbar-track-piece {
  background: #385659;
}

/* 滚动条 颜色 */
.olap_pop_gundong::-webkit-scrollbar-thumb {
  background: #a3a6a0;
  border-radius: 8px;
}

.right_top {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 20px 15px;
  background: rgba(255, 255, 255, 0.1);
}

.recharge,
.ababab {
  width: 100%;

  .pay_specific {
    margin: auto;
    width: calc(100% - 30px);
    padding: 15px 0;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.05);
  }

  .pay {
    display: grid;
    grid-template-rows: auto;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    padding: 15px;

    .pay_type {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 5px;

      img {
        height: 80%;
      }
    }

    .select {
      background: transparent !important;
      box-shadow: 0px 0px 11px 4px rgb(54 193 124) !important;
    }
  }

  .showData {
    width: 70%;
    color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
    background: rgba(255, 255, 255, 0.1);
    padding: 10px;
    margin-left: 10px;
    border-radius: 5px;

    table {
      width: 100%;
      text-align: center;

      td {
        padding-top: 10px;
      }
    }
  }

  .bank {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 15px;

    .bank_select {
      display: flex;
      align-items: center;
    }

    .bank_type {
      display: flex;
    }

    .one,
    .two {
      background: rgba(255, 255, 255, 0.1);
      padding: 5px 10px;
      border-radius: 5px;
      margin-right: 10px;
      cursor: pointer;
    }

    .select {
      background: transparent !important;
      box-shadow: 0px 0px 5px 2px rgb(54 193 124) !important;
    }

    .bank_input {
      display: flex;

      input {
        outline: none;
        border: none;
        height: 24px;
        width: 200px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 5px;
      }

      input:focus {
        border: 1px solid red;
      }
    }
  }

  .money_number {
    display: flex;
    flex-direction: column;
    color: #fff;
    padding: 0 15px;

    .number_input {
      display: flex;
      align-items: center;

      input {
        outline: none;
        border: none;
        background: rgba(255, 255, 255, 0.15);
        height: 30px;
        width: 250px;
        border-radius: 5px;
        padding: 0 10px;
      }
    }

    .money_submit {
      cursor: pointer;
      width: 300px;
      text-align: center;
      padding: 10px 50px;
      font-size: 18px;
      font-weight: 600;
      border-radius: 5px;
      margin-left: 15px;
      margin-top: 20px;
      margin-bottom: 30px;
      background: linear-gradient(1deg,
          rgb(210, 185, 133) 0%,
          rgb(209, 185, 131) 26%,
          rgb(240, 212, 141) 44%,
          rgb(198, 172, 96) 64%,
          rgb(199, 173, 97) 100%);
    }
  }
}

.game_record {
  padding: 0 15px;
  width: 100%;
  color: #fff;
  text-align: center;

  .gameTitle {
    margin-top: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    width: 100%;

    table {
      width: 100%;
    }
  }

  .have_data {
    width: 100%;

    table {
      width: 100%;
    }
  }
}

.transaction {
  padding: 0 15px;
  width: 100%;
  color: #fff;
  text-align: center;

  .transactionTitle {
    margin-top: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    width: 100%;

    table {
      width: 100%;
    }
  }

  .have_data {
    width: 100%;

    table {
      width: 100%;
    }
  }
}

.form {
  width: 70%;
  margin: 30px auto;

  /deep/ input {
    background: rgba(255, 255, 255, 0.15);
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/olay/userPop.vue